import fetch from "auth/FetchInterceptor";

const EmailsService = {};

const emailsEndpointPrefix = "/emailForFormer";

EmailsService.getEmails = async () =>
  await fetch(`${emailsEndpointPrefix}/getAll`, {
    method: "GET",
  });

// EmailsService.getEmailById = async (id) =>
//   await fetch(`${emailsEndpointPrefix}/getById/${id}`, {
//     method: "GET",
//   });

EmailsService.createEmail = async (data) =>
  await fetch(`${emailsEndpointPrefix}/create`, {
    data,
    method: "POST",
  });

EmailsService.deleteEmailById = async (id) =>
  await fetch(`${emailsEndpointPrefix}/deleteById/${id}`, {
    method: "DELETE",
  });

export default EmailsService;
